if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        this.initDesktopThumbnailRail();
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.syncDesktopThumbnailRailHeight();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        this.syncDesktopThumbnailRailHeight();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.isDesktopRailMode()) {
          if (!this.thumbnailList) return;
          const top = thumbnail.offsetTop - this.thumbnailList.clientHeight / 2 + thumbnail.clientHeight / 2;
          this.thumbnailList.scrollTo({ top, behavior: 'smooth' });
          this.updateDesktopThumbnailRailState();
          return;
        }
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      initDesktopThumbnailRail() {
        this.thumbnailList = this.elements.thumbnails.querySelector('.thumbnail-list');
        this.railArrowUp = this.elements.thumbnails.querySelector('.product-thumb-rail__arrow--up');
        this.railArrowDown = this.elements.thumbnails.querySelector('.product-thumb-rail__arrow--down');
        if (!this.thumbnailList || !this.railArrowUp || !this.railArrowDown) return;

        this.railArrowUp.addEventListener('click', () => this.scrollDesktopThumbnailRail(-1));
        this.railArrowDown.addEventListener('click', () => this.scrollDesktopThumbnailRail(1));
        this.thumbnailList.addEventListener('scroll', debounce(this.updateDesktopThumbnailRailState.bind(this), 60));
        window.addEventListener('resize', debounce(this.syncDesktopThumbnailRailHeight.bind(this), 100));
        window.addEventListener('load', this.syncDesktopThumbnailRailHeight.bind(this));
        this.syncDesktopThumbnailRailHeight();
      }

      isDesktopRailMode() {
        return this.dataset.desktopLayout?.includes('thumbnail') && window.matchMedia('(min-width: 900px)').matches;
      }

      scrollDesktopThumbnailRail(direction) {
        if (!this.isDesktopRailMode() || !this.thumbnailList) return;
        const firstThumb = this.thumbnailList.querySelector('.thumbnail-list__item');
        const step = firstThumb ? firstThumb.getBoundingClientRect().height + 12 : 90;
        this.thumbnailList.scrollBy({ top: direction * step * 3, behavior: 'smooth' });
      }

      syncDesktopThumbnailRailHeight() {
        if (!this.elements.thumbnails || !this.isDesktopRailMode()) return;
        const activeMedia =
          this.elements.viewer.querySelector('.product__media-item.is-active') ||
          this.elements.viewer.querySelector('.product__media-item');
        if (!activeMedia) return;

        const mediaHeight = Math.round(activeMedia.getBoundingClientRect().height);
        if (mediaHeight > 0) {
          this.elements.thumbnails.style.setProperty('--desktop-media-height', `${mediaHeight}px`);
        }
        this.updateDesktopThumbnailRailState();
      }

      updateDesktopThumbnailRailState() {
        if (!this.thumbnailList || !this.railArrowUp || !this.railArrowDown) return;

        if (!this.isDesktopRailMode()) {
          this.railArrowUp.classList.add('is-hidden');
          this.railArrowDown.classList.add('is-hidden');
          this.railArrowUp.disabled = true;
          this.railArrowDown.disabled = true;
          return;
        }

        const hasOverflow = this.thumbnailList.scrollHeight > this.thumbnailList.clientHeight + 2;
        this.railArrowUp.classList.toggle('is-hidden', !hasOverflow);
        this.railArrowDown.classList.toggle('is-hidden', !hasOverflow);
        this.railArrowUp.disabled = !hasOverflow || this.thumbnailList.scrollTop <= 2;
        this.railArrowDown.disabled =
          !hasOverflow ||
          this.thumbnailList.scrollTop + this.thumbnailList.clientHeight >= this.thumbnailList.scrollHeight - 2;
      }
    }
  );
}
